import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ZipCodeChip from './ZipCodeChip';
import { ABDM_MIN_ADDRESSES } from '../../../utils/constants';

export default function SelectedZipcodesList({
  selectedZipcodes,
  onSelectZipcode,
}) {
  const totalAddresses = Object.values(selectedZipcodes).reduce(
    (res, demogr) => res + demogr.total_households,
    0,
  );

  const styles = {
    box: {
      height: '35vh',
      paddingTop: '1em',
      paddingBottom: '1em',
      textAlign: 'center',
    },
    textstyle: {
      marginTop: '16px',
    },
  };

  return (
    <div style={styles.box}>
      {Object.keys(selectedZipcodes).length > 0 && (
        <>
          <Stack direction="column" spacing={0.5}>
            {Object.keys(selectedZipcodes).map((zipcode) => (
              <ZipCodeChip
                data-zipcode={selectedZipcodes[zipcode].zip}
                key={selectedZipcodes[zipcode].zip}
                zipcode={selectedZipcodes[zipcode].zip}
                households={selectedZipcodes[zipcode].total_households}
                onClick={() =>
                  onSelectZipcode(selectedZipcodes[zipcode].zip, false)
                }
              />
            ))}
          </Stack>
        </>
      )}
      {(Object.keys(selectedZipcodes).length === 0 ||
        totalAddresses < ABDM_MIN_ADDRESSES) && (
        <Typography variant="body2" gutterBottom sx={styles.textstyle}>
          Selected {totalAddresses}/{ABDM_MIN_ADDRESSES} minimum addresses
        </Typography>
      )}
    </div>
  );
}
